export const VALUE_DISPLAY_CONSTANTS = {
  cardWidth: 290, // Slightly less than actual to be conservative
  gapSize: 5, // Match CSS gap
  badgeHPadding: 16, // 8px * 2 sides from CSS
  plusBadgeWidth: 50, // Width for "+XX" badge
  charWidth: 8, // Conservative character width estimate
};
